import { I18nt } from 'utils';
import { FormFieldValidationRules } from 'utils/interfaces';
import 'config/languages';
import cmValidation from './ConsultaMedicamentos';

export default {
	afiliado: cmValidation.afiliado,
	mayor: [{ required: true, message: I18nt('campo_requerido') }],
	dui: [
		{ len: 10, message: I18nt('len', { len: 9 }) },
		{ required: true, message: I18nt('campo_requerido') },
	],
} as FormFieldValidationRules;
